module.exports = __webpack_public_path__ + "img/size.687ad4a9.svg";